module.exports = __webpack_public_path__ + "static/e1-1a0f241fdecfe15dd58dda628966e41e.png";